import { Link } from "react-router-dom"

export default function Footer1() {
	return (
		<>

			<footer className="footer proplay-footer background-black">
				<div className="footer-widgets py-5">
					<div className="themeflat-container">
						<div className="row footer-top mb-4">
							{/* Brand Column */}
							<div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12 mb-4 mb-lg-0 logo-footer">
								<div className="widget">
									<div className="textwidget">
										<img id="a1" src="images/ProPlayLogo.png" alt="PROPLAY Logo" style={{ height: "62px", width: "auto" }} />
									</div>
								</div>
							</div>
							
							{/* COMPANY */}
							<div className="col-6 col-sm-6 col-md-3 col-lg-2 link-footer mb-4 mb-md-0">
								<div className="widget widget_menu-footer">
									<h5 className="widget-title text-uppercase mb-3" style={{ fontSize: "14px", fontWeight: "700", color: "#8a99ad", letterSpacing: "1px" }}>COMPANY</h5>
									<ul className="menu-footer list-unstyled">
										<li className="mb-2"><Link to="/about" style={{ color: "#c1cfdb" }}>About Us</Link></li>
										<li className="mb-2"><Link to="/about#mission-vision" style={{ color: "#c1cfdb" }}>Our Mission &amp; Vision</Link></li>
										<li className="mb-2"><Link to="/careers" style={{ color: "#c1cfdb" }}>Careers</Link></li>
										<li className="mb-2"><Link to="/contact" style={{ color: "#c1cfdb" }}>Contact Us</Link></li>
									</ul>
								</div>
							</div>

							{/* EXPLORE */}
							<div className="col-6 col-sm-6 col-md-3 col-lg-2 link-footer mb-4 mb-md-0">
								<div className="widget widget_menu-footer">
									<h5 className="widget-title text-uppercase mb-3" style={{ fontSize: "14px", fontWeight: "700", color: "#8a99ad", letterSpacing: "1px" }}>EXPLORE</h5>
									<ul className="menu-footer list-unstyled">
										<li className="mb-2"><Link to="/arenas-academies" style={{ color: "#c1cfdb" }}>Our Arenas &amp; Academies</Link></li>
										<li className="mb-2"><Link to="#" style={{ color: "#c1cfdb" }}>Experiences</Link></li>
										<li className="mb-2"><Link to="#" style={{ color: "#c1cfdb" }}>Membership</Link></li>
									</ul>
								</div>
							</div>

							{/* PARTNER */}
							<div className="col-6 col-sm-6 col-md-3 col-lg-2 link-footer mb-4 mb-md-0">
								<div className="widget widget_menu-footer">
									<h5 className="widget-title text-uppercase mb-3" style={{ fontSize: "14px", fontWeight: "700", color: "#8a99ad", letterSpacing: "1px" }}>PARTNER</h5>
									<ul className="menu-footer list-unstyled">
										<li className="mb-2"><a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" style={{ color: "#c1cfdb" }}>Partner With Us</a></li>
										<li className="mb-2"><Link to="#" style={{ color: "#c1cfdb" }}>Partner Benefits</Link></li>
										<li className="mb-2"><a href="https://book.proplay.zone/" target="_blank" rel="noreferrer" style={{ color: "#c1cfdb" }}>Partner Dashboard</a></li>
									</ul>
								</div>
							</div>

							{/* POLICIES */}
							<div className="col-6 col-sm-6 col-md-3 col-lg-3 link-footer mb-4 mb-md-0">
								<div className="widget widget_menu-footer">
									<h5 className="widget-title text-uppercase mb-3" style={{ fontSize: "14px", fontWeight: "700", color: "#8a99ad", letterSpacing: "1px" }}>POLICIES</h5>
									<ul className="menu-footer list-unstyled mb-4">
										<li className="mb-2"><Link to="#" style={{ color: "#c1cfdb" }}>Privacy Policy</Link></li>
										<li className="mb-2"><Link to="#" style={{ color: "#c1cfdb" }}>Terms &amp; Conditions</Link></li>
										<li className="mb-2"><Link to="#" style={{ color: "#c1cfdb" }}>Refund Policy</Link></li>
									</ul>
									
									<h5 className="widget-title text-uppercase mb-2" style={{ fontSize: "12px", fontWeight: "700", color: "#8a99ad", letterSpacing: "1px" }}>FOLLOW US</h5>
									<div className="social-icon-footer d-flex gap-2">
										<a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-btn"><i className="icon-instagram" /></a>
										<a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-btn"><i className="icon-facebook" /></a>
										<a href="https://youtube.com" target="_blank" rel="noreferrer" className="social-btn"><i className="icon-youtube" /></a>
										<a href="https://linkedin.com" target="_blank" rel="noreferrer" className="social-btn"><i className="icon-linkedin2" /></a>
									</div>
								</div>
							</div>
						</div>

						<div className="row footer-bottom pt-4 border-top border-secondary text-center">
							<div className="col-12">
								<p className="mb-0" style={{ color: "#718294", fontSize: "13px" }}>
									&copy; 2025 PROPLAY. All rights reserved.
								</p>
							</div>
						</div>
					</div>
				</div>
			</footer>

		</>
	)
}
